// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/new-content.svg';

export const NewContent = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
